// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const appUsageResponseSchema = z.object({
  "apps": z.array(z.object({
    "id": z.string().uuid(),
    "unique_users": z.number().int().min(0),
    "last_accessed_at": z.string().datetime({ offset: true })
  }).strict())
}).strict();

export const publicApplicationEntrySchema = z.object({
  "id": z.string().uuid(),
  "label": z.string().min(1).max(100),
  "url": z.string().url(),
  "available": z.boolean()
}).strict().nullable();
